// extracted by mini-css-extract-plugin
export default {"filters":"CatalogFilter_filters__VVoe5","button":"CatalogFilter_button__9gdkj","active":"CatalogFilter_active__oSnaH"};